import { createFileRoute, redirect } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const Page = () => <Index toolKey="premises" routeLang="es" />;

/** Las secciones de contenido tienen URL propia: `?tab=` va con 301. */
const TAB_REDIRECTS: Record<string, string> = {
  library: "/insights",
  tips: "/consejos",
  casos: "/casos-reales",
};

export const Route = createFileRoute("/herramientas/mis-locales")({
  validateSearch: (search: Record<string, unknown>) => ({
    tab: typeof search["tab"] === "string" ? (search["tab"] as string) : undefined,
  }),
  beforeLoad: ({ search }) => {
    const target = search.tab ? TAB_REDIRECTS[search.tab] : undefined;
    if (target) throw redirect({ href: target, statusCode: 301 });
  },
  head: () => publicToolHead("premises", "es"),
  component: Page,
  errorComponent: Page,
  notFoundComponent: Page,
});
